module.exports = __webpack_public_path__ + "img/owdl_qrcode.46837d34.jpg";